// extracted by mini-css-extract-plugin
module.exports = {"ctaSection":"cta-section_ctaSection__D5kiZ","title":"cta-section_title__M7B_1","ctaButton":"cta-section_ctaButton__aL8DU","buttonHolder":"cta-section_buttonHolder__0ei0E"};